(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-video-single"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.video-facade-single').forEach(function (facade) {
    facade.addEventListener('click', function () {
      var videoId = facade.getAttribute('data-youtube-id');
      if (!videoId) return;
      var iframe = document.createElement('iframe');
      iframe.src =
        'https://www.youtube-nocookie.com/embed/' +
        encodeURIComponent(videoId) +
        '?autoplay=1&playsinline=1&rel=0';
      iframe.title = 'Featured Video';
      iframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      facade.replaceWith(iframe);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zipfit-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bindContact = (root) => {
      if (!(root instanceof HTMLElement)) return;
      if (root.dataset.zfContactBound === "true") return;

      const form = root.querySelector("[data-zf-contact-form]");
      if (!form) return;

      root.dataset.zfContactBound = "true";

      const success = root.querySelector("[data-zf-contact-success]");
      const error = root.querySelector("[data-zf-contact-error]");
      const submit = root.querySelector("[data-zf-contact-submit]");
      const header = root.querySelector("[data-zf-contact-header]");

      const showSuccess = () => {
        form.hidden = true;
        if (header) header.hidden = true;
        if (error) error.hidden = true;
        if (success) {
          success.hidden = false;
          success.focus();
        }
        root.classList.add("zf-contact--sent");
      };

      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        if (error) error.hidden = true;

        const endpoint = form.getAttribute("data-endpoint");
        const body = new FormData(form);
        const phone = body.get("phone");
        if (!phone || !String(phone).trim()) {
          body.delete("phone");
        }

        if (submit) submit.disabled = true;

        try {
          const response = await fetch(endpoint, {
            method: "POST",
            body,
            headers: { Accept: "application/json" },
            redirect: "manual",
          });
          const accepted =
            response.ok ||
            response.type === "opaqueredirect" ||
            response.status === 301 ||
            response.status === 302 ||
            response.status === 303 ||
            response.status === 307 ||
            response.status === 308;
          if (!accepted) throw new Error("Request failed");
          showSuccess();
        } catch (_error) {
          if (error) error.hidden = false;
          if (submit) submit.disabled = false;
        }
      });
    };

    const bindWithin = (node) => {
      if (!(node instanceof Element) && !(node instanceof Document)) return;
      if (node instanceof Element && node.matches("[data-zf-contact]")) bindContact(node);
      node.querySelectorAll("[data-zf-contact]").forEach((root) => {
        bindContact(root);
      });
    };

    if (!window.__zfContactListening) {
      window.__zfContactListening = true;
      document.addEventListener("shopify:section:load", (event) => {
        bindWithin(event.target);
      });
    }

    if (document.readyState === "loading") {
      if (!window.__zfContactDomReady) {
        window.__zfContactDomReady = true;
        document.addEventListener("DOMContentLoaded", () => {
          bindWithin(document);
        });
      }
    } else {
      bindWithin(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zipfit-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-zf-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-zf-track]');
    var viewport = root.querySelector('.zf-rv__viewport');
    var prev  = root.querySelector('[data-zf-prev]');
    var next  = root.querySelector('[data-zf-next]');
    if (!track || !prev || !next) return;
    var index = 0;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchActive = false;
    var swipeThreshold = 50;

    function visibleCount() {
      var w = window.innerWidth;
      if (w <= 460) return 1;
      if (w <= 640) return 2;
      if (w <= 880) return 3;
      if (w <= 1080) return 4;
      return 5;
    }
    function isSwipeEnabled() {
      return visibleCount() <= 2;
    }
    function maxIndex() {
      return Math.max(0, track.children.length - visibleCount());
    }
    function update() {
      if (!track.children.length) return;
      var max = maxIndex();
      if (index > max) index = max;
      if (index < 0) index = 0;
      var trackWidth = track.parentElement.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '14') || 14;
      var n = visibleCount();
      var cardWidth = (trackWidth - gap * (n - 1)) / n;
      track.style.transform = 'translateX(' + (-(index * (cardWidth + gap))) + 'px)';
      prev.disabled = index <= 0;
      next.disabled = index >= max;
    }
    prev.addEventListener('click', function () { index -= 1; update(); });
    next.addEventListener('click', function () { index += 1; update(); });
    window.addEventListener('resize', update);

    if (viewport) {
      viewport.addEventListener('touchstart', function (event) {
        if (!isSwipeEnabled() || event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        touchActive = true;
      }, { passive: true });

      viewport.addEventListener('touchend', function (event) {
        if (!touchActive) return;
        touchActive = false;
        if (!isSwipeEnabled()) return;

        var touch = event.changedTouches[0];
        var deltaX = touch.clientX - touchStartX;
        var deltaY = touch.clientY - touchStartY;

        if (Math.abs(deltaX) < swipeThreshold || Math.abs(deltaX) < Math.abs(deltaY)) return;

        if (deltaX < 0) {
          index += 1;
        } else {
          index -= 1;
        }
        update();
      }, { passive: true });

      viewport.addEventListener('touchcancel', function () {
        touchActive = false;
      }, { passive: true });
    }

    update();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
